// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ConfettiBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M14.29 6.225a2.473 2.473 0 0 0-4.075.9L3.652 25.176A2.477 2.477 0 0 0 5.97 28.5c.291 0 .58-.052.855-.152l18.05-6.563a2.474 2.474 0 0 0 .906-4.075L14.29 6.225Zm-1.266 16.676-3.925-3.925 1.268-3.488 6.145 6.145-3.488 1.268Zm-5.053-.814 1.941 1.945-3.056 1.112 1.115-3.056ZM19.625 20.5 11.5 12.375l1.25-3.447L23.07 19.25l-3.446 1.25ZM16 5V2a1.5 1.5 0 0 1 3 0v3a1.5 1.5 0 1 1-3 0Zm14.56 10.439a1.502 1.502 0 1 1-2.125 2.125l-2-2a1.503 1.503 0 0 1 2.125-2.125l2 2Zm-.086-5.017-3 1a1.5 1.5 0 0 1-.95-2.846l3-1a1.5 1.5 0 0 1 .95 2.846Zm-10.9-2.18C19.98 5.933 21.675 4.5 24 4.5c.806 0 1.086-.311 1.25-.615.146-.28.23-.587.25-.902V3a1.5 1.5 0 0 1 3 0c0 1.809-1.199 4.5-4.5 4.5-.618 0-1.276.149-1.47 1.258a1.5 1.5 0 1 1-2.955-.517Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
